import React from 'react';
import styled from 'styled-components';
import { useWindows } from '../../contexts/WindowContext';
import AboutApp from '../Applications/AboutApp/AboutApp';
import SkillsMonitor from '../Applications/SkillsMonitor/SkillsMonitor';
import ProjectsExplorer from '../Applications/ProjectsExplorer/ProjectsExplorer';
import EducationSystem from '../Applications/EducationSystem/EducationSystem';
import AchievementsCenter from '../Applications/AchievementsCenter/AchievementsCenter';
import ContactNetwork from '../Applications/ContactNetwork/ContactNetwork';
import TerminalApp from '../Applications/Terminal/TerminalApp';
import YouTubeChannel from '../Applications/YouTubeChannel/YouTubeChannel';

import HackerGames from '../Applications/HackerGames/HackerGames';


const DockContainer = styled.div`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(0, 255, 0, 0.3);
  border-radius: 12px;
  padding: 8px;
  display: flex;
  gap: 8px;
  backdrop-filter: blur(10px);
  z-index: 1000;

  @media (max-width: 768px) {
    bottom: 8px;
    padding: 6px;
    gap: 6px;
  }
`;

const AppIcon = styled.div<{ isActive?: boolean }>`
  width: 48px;
  height: 48px;
  background: ${props => props.isActive ? 'rgba(0, 255, 0, 0.2)' : 'rgba(51, 51, 51, 0.8)'};
  border: 1px solid ${props => props.isActive ? '#00ff00' : 'transparent'};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 20px;
  position: relative;
  
  &:hover {
    transform: scale(1.1);
    background: rgba(0, 255, 0, 0.1);
    border-color: #00ff00;
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
`;

const Tooltip = styled.div`
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.9);
  color: #00ff00;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
  border: 1px solid rgba(0, 255, 0, 0.3);

  ${AppIcon}:hover & {
    opacity: 1;
  }
`;

const Dock: React.FC = () => {
  const { openWindow, windows, restoreWindow, focusWindow } = useWindows();

  const apps = [
    { 
      name: 'About', 
      icon: '👤', 
      component: AboutApp,
      title: 'About Mukul Joshi'
    },
    { 
      name: 'Skills', 
      icon: '⚡', 
      component: SkillsMonitor,
      title: 'Skills Monitor'
    },
    { 
      name: 'Projects', 
      icon: '📁', 
      component: ProjectsExplorer,
      title: 'Projects Explorer'
    },
    { 
      name: 'Education', 
      icon: '🎓', 
      component: EducationSystem,
      title: 'Education System'
    },
    { 
      name: 'Achievements', 
      icon: '🏆', 
      component: AchievementsCenter,
      title: 'Achievements Center'
        },
        
     
    {
      name: 'Games',
      icon: '👾',
      component: HackerGames,
      title: 'Hacker Games'
    },

    
    
    { 
      name: 'YouTube', 
      icon: '📺', 
      component: YouTubeChannel,
      title: 'CYB3RFY YouTube Channel'
    },
    { 
      name: 'Contact', 
      icon: '📞', 
      component: ContactNetwork,
      title: 'Contact Network'
    },
    { 
      name: 'Terminal', 
      icon: '💻', 
      component: TerminalApp,
      title: 'Terminal Emulator'
    },
  ];

  const handleAppClick = (app: typeof apps[0]) => {
    const existingWindow = windows.find(w => w.title === app.title);
    if (existingWindow) {
      if (existingWindow.isMinimized) {
        restoreWindow(existingWindow.id);
      } else {
        focusWindow(existingWindow.id);
      }
    } else {
      openWindow({
        title: app.title,
        component: app.component,
        isMinimized: false,
        isMaximized: false,
        position: { x: 100 + Math.random() * 200, y: 100 + Math.random() * 100 },
        size: { width: 800, height: 600 }
      });
    }
  };

  return (
    <DockContainer>
      {apps.map((app) => {
        const isActive = windows.some(w => w.title === app.title && !w.isMinimized);
        return (
          <AppIcon 
            key={app.name} 
            isActive={isActive}
            onClick={() => handleAppClick(app)}
          >
            {app.icon}
            <Tooltip>{app.name}</Tooltip>
          </AppIcon>
        );
      })}
    </DockContainer>
  );
};

export default Dock;
